function video(){
    jQuery('.block.video .video-container').click(function(){
        var $this = jQuery(this);

        if(!$this.hasClass('initialized')){
            var iframe = '';
            if($this.attr('data-type') === 'youtube'){
                iframe = '<iframe src="https://www.youtube.com/embed/'+ $this.attr('data-embed') +'?autoplay=1" width="' + $this.width() + 'px" height="' + $this.height() + 'px" allowfullscreen>';
            }
            if($this.attr('data-type') === 'vimeo'){
                iframe = '<iframe src="https://player.vimeo.com/video/'+ $this.attr('data-embed') +'" width="' + $this.width() + 'px" height="' + $this.height() + 'px" frameborder="0" allow="autoplay; fullscreen" allowfullscreen">';
            }
            $this.html(iframe).addClass('initialized'); 
        }
    });
}
